// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/components/home/AfterSale.less
// module id = 2893
// module chunks = 0